import {DELETE_NATURE_MAGAZINE_START} from "../../types";

export const delete_nature_magazine = (payload) => ({
    type: DELETE_NATURE_MAGAZINE_START,
    payload,
});
